import React from "react";
import {
  Box,
  Container,
  Heading,
  Text,
  VStack,
  HStack,
  SimpleGrid,
  Image,
  useColorModeValue,
  Divider,
} from "@chakra-ui/react";

const AtAGlance = ({ product }) => {
  const textColor = useColorModeValue("gray.600", "gray.300");
  const headingColor = useColorModeValue("gray.800", "white");

  if (!product) {
    return null;
  }

  return (
    <Box py={16} borderRadius="xl" mt={8}>
      <Container maxW="7xl" px={6}>
        {/* Header with Badge */}
        <VStack spacing={6} align="start" mb={12}>
          <HStack justify="space-between" w="full" flexWrap="wrap">
            <HStack spacing={4} flexWrap="wrap">
              <Text
                fontSize={{ base: "2xl", md: "4xl" }}
                color={"rgba(0, 11, 140, 1)"}
                fontWeight="bold"
                lineHeight="shorter"
              >
                {product.title}
              </Text>
              <Text
                fontSize={{ base: "2xl", md: "4xl" }}
                fontWeight="bold"
                lineHeight="shorter"
                color={headingColor}
              >
                At a Glance
              </Text>
            </HStack>
          </HStack>

          <Text
            fontSize={{ base: "md", md: "lg" }}
            color={textColor}
            lineHeight="tall"
            maxW="6xl"
          >
            {product.description}
          </Text>
        </VStack>

        <VStack spacing={8} mb={12} align="start">
          {product.mission && (
            <Box w="full">
              <HStack spacing={4} mb={4}>
                <Image
                  src="/png/mission.png"
                  alt="Mission icon"
                  boxSize={12}
                  objectFit="contain"
                />
                <Text fontSize="2xl" fontWeight="bold" color="gray.800">
                  Mission
                </Text>
              </HStack>
              <Text fontSize="md" color={textColor} lineHeight="tall">
                {product.mission}
              </Text>
            </Box>
          )}

          {/* Vision Section */}
          {product.vision && (
            <Box w="full">
              <HStack spacing={4} mb={4}>
                <Image
                  src="/png/vision.png"
                  alt="Vision icon"
                  boxSize={12}
                  objectFit="contain"
                />
                <Text fontSize="2xl" fontWeight="bold" color="gray.800">
                  Vision
                </Text>
              </HStack>
              <Text fontSize="md" color={textColor} lineHeight="tall">
                {product.vision}
              </Text>
            </Box>
          )}
        </VStack>

        {/* Enhanced Stats Section */}
        {product.stats && product.stats.length > 0 && (
          <>
            <Divider my={8} />
            <VStack spacing={6} mb={12}>
              {/* <Heading
                as="h3"
                size="lg"
                color={headingColor}
                textAlign="center"
              >
                Key Statistics
              </Heading> */}
              <SimpleGrid
                columns={{ base: 1, sm: 2, md: 3, lg: 5 }}
                spacing={6}
                w="full"
              >
                {product.stats.map((stat, index) => (
                  <Box
                    key={index}
                    p={6}
                    borderRadius="lg"
                    textAlign="center"
                    transition="all 0.3s"
                    _hover={{
                      transform: "translateY(-4px)",
                      bg: "blue.50",
                      borderColor: "blue.200",
                    }}
                    border="1px"
                    borderColor="gray.200"
                  >
                    <VStack spacing={4}>
                      {/* Show iconImage only if available from API */}
                      {stat.iconImage && (
                        <Image
                          src={stat.iconImage}
                          alt={`${stat.label} icon`}
                          boxSize={10}
                          objectFit="contain"
                        />
                      )}
                      <Heading
                        as="h4"
                        size="lg"
                        color={"rgba(0, 11, 140, 1)"}
                        fontWeight="bold"
                      >
                        {stat.number}
                      </Heading>
                      <Text
                        fontSize="sm"
                        color={textColor}
                        fontWeight="medium"
                        textAlign="center"
                        lineHeight="short"
                      >
                        {stat.label}
                      </Text>
                    </VStack>
                  </Box>
                ))}
              </SimpleGrid>
            </VStack>
          </>
        )}
      </Container>

      {/* Product Detail Image */}
      {product.detailImage && (
        <Box mt={16} display="flex" justifyContent="center" alignItems="center">
          <Box borderRadius="xl" overflow="hidden" maxW="5xl" w="full" mx={6}>
            <img
              src={product.detailImage}
              alt={`${product.title} At a Glance`}
              style={{
                width: "100%",
                height: "auto",
                display: "block",
              }}
            />
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default AtAGlance;
